import {
  fetchNavState,
  NavState,
  RedirectError,
} from '@amzn/aac-chrome-internal-api';
import ChromeInternalApiRequestConfig from './chrome-internal-api-request-config';

export default async (): Promise<NavState> => {
  try {
    if (window.AACChrome?.InternalAPI) {
      return window.AACChrome.InternalAPI.NavStateHandler.getInstance().getNavState(
        ChromeInternalApiRequestConfig,
      );
    }
    return fetchNavState(ChromeInternalApiRequestConfig);
  } catch (error: any) {
    // redirect to redirectUrl if the API returns 302
    if (
      window &&
      error &&
      error.type === RedirectError.TYPE &&
      error.redirectUrl
    ) {
      window.location.replace(error.redirectUrl);
    }
    throw error;
  }
};
